import Window from 'window-or-global'
import { toStartDate, toEndDate } from '@/helpers/date.js'
import { getDeepProperty } from '@/helpers/deepObject.js'

export const getEntityCollection = (
  entity,
  key
) => getDeepProperty(entity, `${key}.collection`)

export const getOptionsString = options => {
  // TODO: refactor to use map and/or reduce: https://app.asana.com/0/1200062349227021/1200342047459563/f
  let optionsArray = []

  Object.entries(options).forEach(([key, value]) => {
    let optionString = null

    if (key === 'analytics') {
      optionString = 'analytics=true'
    }

    if (key === 'sort' && value) {
      optionString = `sort=${value}`
    }

    if (key === 'status' && value) {
      optionString = `status=${value}`
    }

    if (key === 'title' && value) {
      optionString = `title=${value}`
    }

    if (key === 'search' && value !== '') {
      optionString = `search=${value}`
    }

    // Used specifically for campaigns as a search term, vs using the key 'search'
    if (key === 'name_filter' && value !== '') {
      optionString = `name_filter=${value}`
    }

    // Used specifically for campaigns to filter by label
    if (key === 'label_filter' && value !== '' && value !== 'all') {
      optionString = `label_filter=${value}`
    }

    // Used specifically for campaigns to filter by show
    if (key === 'show_filter' && value !== '' && value !== 'all') {
      optionString = `show_filter=${value}`
    }

    if (key === 'podcast' && value !== '' && value !== 'all') {
      optionString = `podcast=${value}`
    }

    if (key === 'network' && value !== '' && value !== 'all') {
      optionString = `network=${value}`
    }

    if (key === 'fields' && value.length) {
      optionString = `fields=${value.join(',')}`
    }

    if (key === 'statusFilters' && value.length) {
      optionString = `status=${value.join(',')}`
    }

    if (key === 'typeFilters' && value.length) {
      optionString = `type=${value.join(',')}`
    }

    if (key === 'feedFilters' && value.length) {
      optionString = `feed_ids=${value.join(',')}`
    }

    // Used specifically for organization user list to filter by option id
    if (key === 'filter' && value.length) {
      optionString = `filter=${value.join(',')}`
    }

    if (key === 'offset') {
      optionString = `offset=${value}`
    }

    if (key === 'limit') {
      optionString = `limit=${value}`
    }

    if (key === 'preview') {
      optionString = `preview=${value}`
    }

    if (key === 'year') {
      optionString = `year=${value}`
    }

    if (key === 'cached') {
      optionString = `cached=${value}`
    }

    if (key === 'hide_imported') {
      optionString = `hide_imported=${value}`
    }

    if (key === 'perms') {
      optionString = `perms=${value}`
    }

    if (key === 'permission_ids') {
      optionString = `permission_ids=${value}`
    }

    if (key === 'default') {
      optionString = `default=${value}`
    }

    if (key === 'account') {
      optionString = `account=${value}`
    }

    if (key === 'include_pending') {
      optionString = `include_pending=${value ? 'true' : 'false'}`
    }

    if (key === 'advertiser_ids' && value.length) {
      optionString = `advertiser_ids=${value.join(',')}`
    }

    if (key === 'campaign_ids' && value.length) {
      optionString = `campaign_ids=${value.join(',')}`
    }

    if (key === 'random') {
      optionString = `random=${value ? 'true' : 'false'}`
    }

    if (key === 'sort_by_user') {
      optionString = `sort_by_user=${value}`
    }

    if (key === 'archived') {
      optionString = `archived=${value}`
    }

    if (key === 'exclude_enabled') {
      optionString = `exclude_enabled=${value}`
    }

    if (key === 'podcasts_enabled') {
      optionString = `podcasts_enabled=${value.join(',')}`
    }

    if (optionString) {
      optionsArray.push(optionString)
    }
  })

  return optionsArray.join('&')
}

export const getMapQueryString = (params) => {
  const startDate = params.timeframe.start
  const endDate = params.timeframe.end
  // where bounds is a mapbox bounds object
  let str = ''
  if (params.episode) {
    str = `?episode=${params.episode}`
  } else if (params.podcast) {
    str = `?podcast=${params.podcast}`
  } else if (params.network) {
    str = `?network=${params.network}`
  } else if (params.account) {
    str = `?account=${params.account}`
  } else {
    Window.console.error('getMapQueryString: You must pass an account, network, podcast, or episode ID')
    return ''
  }
  if (params.bounds) {
    const n = preventOutOfBounds(params.bounds.getNorth())
    const s = preventOutOfBounds(params.bounds.getSouth())
    const e = preventOutOfBounds(params.bounds.getEast())
    const w = preventOutOfBounds(params.bounds.getWest())
    str += `&nlat=${n}&slat=${s}&elon=${e}&wlon=${w}`
  }
  if (startDate && !params.release) {
    str += `&start_date=${toStartDate(startDate)}`
  }
  if (endDate && !params.release) {
    str += `&end_date=${toEndDate(endDate)}`
  }
  if (params.release) {
    str += `&release=${params.release}`
  }
  return str
}

export const preventOutOfBounds = point => {
  if (point > 180) return 180
  if (point < -180) return -180
  return point
}
